/* eslint-disable @next/next/no-img-element */
"use client";
import FacilityItem from "@/components/FacilityItem";
import FacilitiesList from "@/components/FacilitiesList";
import { GROUP } from "@/utils/constants/group";
import type { FacilidadeType } from "@/types/facilities";
import type { ServiceProps } from "@/types/services";
import type { ModalProps } from "../StoreDetail";
import styles from "./styles.module.scss";

export type FacilitiesProps = {
  facilidades: FacilidadeType[];
  servicos: ServiceProps[] | [];
  // eslint-disable-next-line no-unused-vars
  onShowModal: (modalData: ModalProps) => void;
};

const Facilities = ({
  facilidades,
  servicos,
  onShowModal
}: FacilitiesProps) => {
  const hasDifferences = facilidades.some(
    (item: FacilidadeType) => item.group === GROUP.DIFFERENCES.id
  );

  const hasService = facilidades.some(
    (item: FacilidadeType) => item.group === GROUP.SERVICE.id
  );

  const hasProductCategories = facilidades.some(
    (item: FacilidadeType) => item.group === GROUP.PRODUCT_CATEGORIES.id
  );

  const hasServices = servicos.map(({ name, description }) => ({
    group: "Servicos",
    name,
    description,
    subtitle: description,
    icon:
      name === "Banho e Tosa"
        ? "banho-e-tosa"
        : name === "Veterinário"
          ? "home-alt"
          : "default",
    petanjo: false,
    link: ""
  }));

  const modalContent = (
    <>
      {hasDifferences && (
        <FacilitiesList
          {...GROUP.DIFFERENCES}
          facilidades={facilidades}
          divider
        />
      )}
      {hasService && (
        <FacilitiesList {...GROUP.SERVICE} facilidades={facilidades} divider />
      )}
      {hasProductCategories && (
        <FacilitiesList
          {...GROUP.PRODUCT_CATEGORIES}
          facilidades={facilidades}
          divider
        />
      )}
      {hasServices && (
        <FacilitiesList {...GROUP.SERVICES} facilidades={hasServices} />
      )}
    </>
  );

  return (
    <div className={styles.wrapper}>
      <h2 className="subtitle-lg">Facilidades que esta loja possui:</h2>
      <ul>
        {facilidades
          .slice(0, 10)
          .map(
            (
              { name, subtitle, icon, group }: FacilidadeType,
              index: number
            ) => (
              <li key={index}>
                <FacilityItem
                  name={name}
                  subtitle={subtitle}
                  icon={icon}
                  group={group}
                />
              </li>
            )
          )}
        {facilidades.length < 10 && facilidades.length % 2 !== 0 && <li></li>}
      </ul>
      <button
        className="btn outlined"
        onClick={() =>
          onShowModal({
            open: true,
            title: "Facilidades que esta loja possui:",
            content: modalContent
          })
        }
      >
        Mostrar todas as facilidades
      </button>
    </div>
  );
};

export default Facilities;
